export enum PlayerLogDescription {
    START_PLAYER = 'start-player',
    FAIL_START_PLAYER = 'fail-start-player',
    CLOSE_PLAYER = 'close-player',
    CONNECT_VD_AGENT = 'connect-vdagent',
    DISCONNECT_VD_AGENT = 'disconnect-vdagent',
}
